import axios from "axios";
import {detailServicesPath} from "../../../Constants";

const detailControllerRestUrl = detailServicesPath + '/organizations/points'

export default class PointControllerServiceOrganization {
    static async save(afterPointId, data) {
        return await axios.post(`${detailControllerRestUrl}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            },
            params: {afterPointId: afterPointId}
        });
    }

    static async delete(pointID) {
        return await axios.delete(`${detailControllerRestUrl}/${pointID}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async patch(pointID, data) {
        return await axios.patch(`${detailControllerRestUrl}/${pointID}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async patchArc(pointID, data) {
        return await axios.patch(`${detailControllerRestUrl}/${pointID}/arc`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async patchRound(pointID, data) {
        return await axios.put(`${detailControllerRestUrl}/${pointID}/round`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async patchCut(pointID, data) {
        return await axios.put(`${detailControllerRestUrl}/${pointID}/cut`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }


    static async previewArc(pointID, data) {
        return await axios.put(`${detailControllerRestUrl}/${pointID}/preview-arc`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async previewRound(pointID, data) {
        return await axios.put(`${detailControllerRestUrl}/${pointID}/preview-round-corner`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}
